export const translations = {
  en: {
    // Navigation
    home: 'Home',
    properties: 'Properties',
    about: 'About',
    contact: 'Contact',
    login: 'Login',
    signup: 'Sign Up',
    logout: 'Logout',
    
    // User dropdown
    myProfile: 'My Profile',
    viewedProperties: 'Viewed Properties',
    myRequests: 'My Requests',
    settings: 'Settings',
    
    // Language selector
    language: 'Language',
    english: 'English',
    arabic: 'Arabic',

    // Profile page
    accountInfo: 'Account Information',
    edit: 'Edit',
    cancel: 'Cancel',
    fullName: 'Full Name',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    address: 'Address',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    notProvided: 'Not provided',
    memberSince: 'Member Since',
    noUserData: 'No user data available',

    // Viewed properties
    recentlyViewedProperties: 'Recently Viewed Properties',
    beds: 'Beds',
    baths: 'Baths',
    sqft: 'sqft',
    viewedOn: 'Viewed on',
    viewAgain: 'View Again',
    noPropertiesViewed: 'You haven\'t viewed any properties yet.',
    browseProperties: 'Browse Properties',

    // Maintenance requests
    maintenanceRequests: 'Maintenance Requests',
    newRequest: 'New Request',
    submittedOn: 'Submitted on',
    adminResponse: 'Admin Response:',
    noMaintenanceRequests: 'You don\'t have any maintenance requests yet.',
    submitRequest: 'Submit a Request',

    // Status
    pending: 'Pending',
    inProgress: 'In Progress',
    completed: 'Completed',
    rejected: 'Rejected',

    // Settings
    accountSettings: 'Account Settings',
    password: 'Password',
    changePassword: 'Change Password',
    notifications: 'Notifications',
    emailNotifications: 'Email Notifications',
    smsNotifications: 'SMS Notifications',
    privacy: 'Privacy',
    savePropertyViewHistory: 'Save Property View History',
    account: 'Account',
    deactivateAccount: 'Deactivate Account',

    // Sidebar
    accountInfoShort: 'Account Info',

    // Messages
    profileUpdated: 'Profile updated successfully',
    failedToUpdate: 'Failed to update profile',

    // Admin sidebar
    adminTitle: 'Real Estate Admin',
    backToWebsite: 'Back to Website',
    dashboard: 'Dashboard',
    maintenance: 'Maintenance',
    whatsapp: 'WhatsApp',
    users: 'Users',
    income: 'Income',
    analytics: 'Analytics',
    
    // Admin login
    adminLogin: 'Admin Login',
    adminLoginSubtitle: 'Enter your credentials to access the admin dashboard',
    username: 'Username',
    enterUsername: 'Enter your username',
    enterPassword: 'Enter your password',
    invalidCredentials: 'Invalid admin credentials',

    // Maintenance request page
    maintenanceRequestForm: 'Maintenance Request Form',
    maintenanceRequestSubtitle: 'Submit your maintenance request and we\'ll get right on it',
    maintenanceType: 'Type of Maintenance',
    selectMaintenanceType: 'Select maintenance type',
    electrical: 'Electrical',
    plumbing: 'Plumbing',
    airConditioning: 'Air Conditioning',
    heating: 'Heating',
    applianceRepair: 'Appliance Repair',
    structural: 'Structural',
    pestControl: 'Pest Control',
    other: 'Other',
    problemDescription: 'Description of the Problem',
    descriptionPlaceholder: 'Please describe the issue in detail...',
    problemQuality: 'Problem Quality',
    urgent: 'Urgent',
    normal: 'Normal',
    lowPriority: 'Low Priority',
    preferredVisitDate: 'Preferred Visit Date',
    uploadImages: 'Upload Images',
    submitRequest: 'Submit Request',
  },
  ar: {
    // Navigation
    home: 'الرئيسية',
    properties: 'العقارات',
    about: 'من نحن',
    contact: 'اتصل بنا',
    login: 'تسجيل الدخول',
    signup: 'إنشاء حساب',
    logout: 'تسجيل الخروج',
    
    // User dropdown
    myProfile: 'الملف الشخصي',
    viewedProperties: 'العقارات المشاهدة',
    myRequests: 'طلباتي',
    settings: 'الإعدادات',
    
    // Language selector
    language: 'اللغة',
    english: 'الإنجليزية',
    arabic: 'العربية',

    // Profile page
    accountInfo: 'معلومات الحساب',
    edit: 'تعديل',
    cancel: 'إلغاء',
    fullName: 'الاسم الكامل',
    emailAddress: 'البريد الإلكتروني',
    phoneNumber: 'رقم الهاتف',
    address: 'العنوان',
    saveChanges: 'حفظ التغييرات',
    saving: 'جاري الحفظ...',
    notProvided: 'غير متوفر',
    memberSince: 'عضو منذ',
    noUserData: 'لا توجد بيانات متاحة للمستخدم',

    // Viewed properties
    recentlyViewedProperties: 'العقارات المشاهدة مؤخراً',
    beds: 'غرف',
    baths: 'حمامات',
    sqft: 'قدم مربع',
    viewedOn: 'تمت المشاهدة في',
    viewAgain: 'مشاهدة مرة أخرى',
    noPropertiesViewed: 'لم تقم بمشاهدة أي عقارات حتى الآن.',
    browseProperties: 'تصفح العقارات',

    // Maintenance requests
    maintenanceRequests: 'طلبات الصيانة',
    newRequest: 'طلب جديد',
    submittedOn: 'تم التقديم في',
    adminResponse: 'رد المسؤول:',
    noMaintenanceRequests: 'ليس لديك أي طلبات صيانة حتى الآن.',
    submitRequest: 'تقديم طلب',

    // Status
    pending: 'قيد الانتظار',
    inProgress: 'قيد التنفيذ',
    completed: 'مكتمل',
    rejected: 'مرفوض',

    // Settings
    accountSettings: 'إعدادات الحساب',
    password: 'كلمة المرور',
    changePassword: 'تغيير كلمة المرور',
    notifications: 'الإشعارات',
    emailNotifications: 'إشعارات البريد الإلكتروني',
    smsNotifications: 'إشعارات الرسائل القصيرة',
    privacy: 'الخصوصية',
    savePropertyViewHistory: 'حفظ سجل مشاهدة العقارات',
    account: 'الحساب',
    deactivateAccount: 'إلغاء تنشيط الحساب',

    // Sidebar
    accountInfoShort: 'معلومات الحساب',

    // Messages
    profileUpdated: 'تم تحديث الملف الشخصي بنجاح',
    failedToUpdate: 'فشل تحديث الملف الشخصي',

    // Admin sidebar
    adminTitle: 'لوحة إدارة العقارات',
    backToWebsite: 'العودة إلى الموقع',
    dashboard: 'لوحة التحكم',
    maintenance: 'الصيانة',
    whatsapp: 'واتساب',
    users: 'المستخدمون',
    income: 'الدخل',
    analytics: 'التحليلات',
    
    // Admin login
    adminLogin: 'لوحة إدارة العقارات',
    adminLoginSubtitle: 'أدخل بيانات الاعتماد للوصول إلى لوحة تحكم المسؤول',
    username: 'اسم المستخدم',
    enterUsername: 'أدخل اسم المستخدم',
    enterPassword: 'أدخل كلمة المرور',
    invalidCredentials: 'بيانات اعتماد المسؤول غير صالحة',

    // Maintenance request page
    maintenanceRequestForm: 'نموذج طلب الصيانة',
    maintenanceRequestSubtitle: 'قدم طلب الصيانة الخاص بك وسنقوم بالرد فوراً',
    maintenanceType: 'نوع الصيانة',
    selectMaintenanceType: 'اختر نوع الصيانة',
    electrical: 'كهربائي',
    plumbing: 'سباكة',
    airConditioning: 'تكييف الهواء',
    heating: 'تدفئة',
    applianceRepair: 'إصلاح الأجهزة',
    structural: 'هيكلي',
    pestControl: 'مكافحة الحشرات',
    other: 'أخرى',
    problemDescription: 'وصف المشكلة',
    descriptionPlaceholder: 'يرجى وصف المشكلة بالتفصيل...',
    problemQuality: 'مستوى المشكلة',
    urgent: 'عاجل',
    normal: 'عادي',
    lowPriority: 'أولوية منخفضة',
    preferredVisitDate: 'تاريخ الزيارة المفضل',
    uploadImages: 'تحميل الصور',
    submitRequest: 'تقديم الطلب',
  }
};
